import { Component, ViewEncapsulation } from '@angular/core';
import { Event, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { UI_STRINGS } from '../../../../functions/language/uistrings';

@Component({
    selector: 'app-route-load-indicator',
    templateUrl: './route-load-indicator.component.html',
    styleUrls: ['./route-load-indicator.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RouteLoadIndicatorComponent {
  loading: boolean = false;
  UI_STRINGS = UI_STRINGS.GLOBAL;

  constructor(private _router: Router) {
    this._router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.loading = false;
      }
    });
  }
}
